<template>
    <div>
        <div class="boxbranco busca-movimentacao">
            <titulo classeAwesome="fa fa-file-text-o" nome="Histórico de Movimentação de Leitos" />


            <div class="row">
                <div class="form-group col-sm-6">
                    <label for="unidade">Unidade</label>
                    <multiselect
                        :options="listaUnidades"
                        track-by="nomeCnes"
                        label="nomeCnes"
                        :searchable="true"
                        placeholder="Pesquise e selecione"
                        selectLabel="+"
                        deselectLabel="-" 
                        selectedLabel="selecionado"
                        v-model="unidade"
                        >

                        <span slot="noResult">Nenhum resultado encontrado.</span>
                    </multiselect>
                </div>

                <div class="col-sm-3 form-group">
                    <label for="data-pickerinicio">Início</label>
                    <datepicker
                        v-model="dataInicio"
                        :format="formatoData"
                        :disabled="dateDisabled"
                        language="pt-br"
                        id="data-pickerinicio"
                        calendar-button
                        calendar-button-icon="fa fa-calendar"
                        >
                    </datepicker>
                </div>

                <div class="col-sm-3 form-group">
                    <label for="data-picker">Fim</label>
                    <datepicker
                        v-model="dataFim"
                        :format="formatoData"
                        :disabled="dateDisabled"
                        language="pt-br"
                        id="data-picker"
                        calendar-button
                        calendar-button-icon="fa fa-calendar"
                        >
                    </datepicker>
                </div>
            </div>

            <b-button
                @click="buscaHistorico"
                variant="primary"
                :disabled="unidade == null || rangeDatas == false ? true : false"
            >
                Pesquisar <i class="fa fa-search" aria-hidden="true"></i>
            </b-button>

             <button type="button" class="ml-2 btn btn-success" v-if="historico">
                <download-excel
                    :data="historico"
                    :fields="excelColunas"
                    worksheet="Movimentacao"
                    name="historicomovimentacao.xls"
                    >
                    <i class="fa fa-file-excel-o" aria-hidden="true"></i> Exportar para Excel
                </download-excel>
            </button>

            <div v-if="rangeDatas == false" class="alert alert-danger mt-4" role="alert">Distância entre datas permitida para pesquisa é de no máximo 7 dias</div>

        </div>

        <div class="boxbranco historico-movimentacao mt-3" v-if="historico">

            <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-3 form-group">
                    <label for="filtro">Filtrar</label>
                    <input class="form-control" v-model="filter">
                </div>
            </div>

           <p>Resultados encontrados:<strong> {{historico.length}}</strong></p>

        
            <b-table
                class="mt-2"
                responsive
                striped
                bordered
                hover
                :items="historico"
                :fields="colunas"
                thead-class="tcabecario"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                @filtered="onFiltered"
            >
            </b-table>

            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="mt-2"
            ></b-pagination>

        </div>


    </div>
</template>

<script>
import moment from "moment"
import Titulo from '../../shared/titulo/Titulo.vue'
import Datepicker from 'vuejs-datepicker'
export default {
    components: {
        Titulo,
        Datepicker
    },
    created () {
        this.$store.dispatch('filtro/pegaListaUnidades')
    },
    data () {
        return {
            formatoData: 'dd/MM/yyyy',
            dateDisabled: {
                from: new Date(),
            },
            unidade: null,
            dataInicio: new Date(),
            dataFim: new Date(),

            colunas: [
                { key: 'nomeUnidade', label: 'Unidade', class: 'text-center' },
                { key: 'grupoTipoClinico', label: 'Grupo', class: 'text-center' },
                { key: 'tipoClinico', label: 'Tipo Clínico', class: 'text-center' },
                { key: 'codigoEnfermaria', label: 'Enfermaria', class: 'text-center' },
                { key: 'codigoLeito', label: 'Leito', class: 'text-center' },
                { key: 'nomePaciente', label: 'Paciente', class: 'text-center' },
                { key: 'cnsPaciente', label: 'CNS', class: 'text-center' },
                { key: 'dataHoraInternacao', label: 'Data/Hora Admissão', class: 'text-center' },
                { key: 'profissionalInternacao', label: 'Profissional Admissão', class: 'text-center' },
                { key: 'pnrInternacao', label: 'Prof. Inter. é NR?', class: 'text-center' },
                { key: 'dataHoraAlta', label: 'Data/Hora Saída', class: 'text-center' },
                { key: 'profissionalAlta', label: 'Profissional Saída', class: 'text-center' },
                { key: 'pnrAlta', label: 'Prof. Saída é NR?', class: 'text-center' },
                { key: 'transferenciaInterna', label: 'Transferência Interna', class: 'text-center' },
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            filter: null,

             excelColunas: {
                'Unidade': 'nomeUnidade',
                'Grupo': 'grupoTipoClinico',
                'Tipo Cínico': 'tipoClinico',
                'Enfermaria': 'codigoEnfermaria',
                'Leito': 'codigoLeito',
                'Nome': 'nomePaciente',
                'CNS do Paciente Internado':  {
                    field: 'cnsPaciente',
                    callback: (value) => {
                        if (value == '') return ''
                        else return `="${value}"`;
                    }
                },
                'Data Hora da Admissão': 'dataHoraInternacao',
                'Profissional Admissão': 'profissionalInternacao',
                'Prof. Intern. é NR?': 'pnrInternacao',
                'Data/Hora Saída': 'dataHoraAlta',
                'Profissional Saída': 'profissionalAlta',
                'Prof. Saída é NR?': 'pnrAlta',
                'Transf. Interna': 'transferenciaInterna',
            }
        }
    },
    computed: {
        listaUnidades () {
            return this.$store.getters['filtro/getListaUnidades']
        },
        historico () {
            return this.$store.getters['relatorios/getHistoricoMovimentacao']
        },
        rangeDatas () {
            let de = this.dataInicio.getTime()
            let ate = this.dataFim.getTime()
            
            let dias = 86400000 * 7;
            let diferenca = ate - de;

            if (diferenca > dias) return false
            else true
        }
    },
    methods: {
        formatadata (date) {
            return moment(date).format("YYYY-MM-DD")
        },
        buscaHistorico () {
            let dados = {
                dataInicial: this.formatadata(this.dataInicio),
                dataFinal: this.formatadata(this.dataFim),
                cnes: this.unidade.cnes
            }

            this.$store.dispatch('relatorios/historicoMovimentacao', dados).then(() => {
                this.totalRows = this.historico.length
            })
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        }
    },
}
</script>

<style>
.busca-movimentacao {
    max-width: 900px;
    width: 96%;
    margin: 0 auto;
}

.historico-movimentacao {
    max-width: 1920px;
    width: 96%;
    margin: 0 auto;
}

.table th,
.table td {
  font-size: 12px!important;
  padding: 8px!important;
  vertical-align: middle!important;
}

.tcabecario {
  background-color: #f3f2f2;
}

</style>